export enum SuggestionType {
    HISTORY = 'HISTORY',
    SOFTWARE = 'SOFTWARE',
    PLATFORM = 'PLATFORM'
  }
  